import clsx from 'clsx';
import React from 'react';

type AlignmentType = "start" | "end" | "center" | "baseline" | "stretch";
type Size = "half" | "full";

export function FlexRow({ items = "start", onClick, className, children }: {
  items?:     AlignmentType,
  onClick?:   React.MouseEventHandler<HTMLDivElement>,
  className?: string,
  children?:  React.ReactNode,
}) {
  return (
    <div onClick={onClick} className={clsx(
      "flex flex-row",
      {
        "items-start":    items === "start",
        "items-end":      items === "end",
        "items-center":   items === "center",
        "items-baseline": items === "baseline",
        "items-stretch":  items === "stretch",
      },
      className
    )}>
      {children}
    </div>
  );
}
export function FlexCol({ items = "start", onClick, className, children }: {
  items?:     AlignmentType,
  onClick?:   React.MouseEventHandler<HTMLDivElement>,
  className?: string,
  children?:  React.ReactNode,
}) {
  return (
    <div onClick={onClick} className={clsx(
      "flex flex-col",
      {
        "items-start":    items === "start",
        "items-end":      items === "end",
        "items-center":   items === "center",
        "items-baseline": items === "baseline",
        "items-stretch":  items === "stretch",
      },
      className
    )}>
      {children}
    </div>
  );
}
export function FlexAuto({ className, children }: { className?: string, children?: React.ReactNode }) {
  return (
    <div className={clsx("flex-auto", className)}>
      {children}
    </div>
  );
}
export function FlexNone({ onClick, className, children }: {
  onClick?:   React.MouseEventHandler<HTMLDivElement>,
  className?: string,
  children?:  React.ReactNode,
}) {
  return (
    <div onClick={onClick} className={clsx("flex-none", className)}>
      {children}
    </div>
  );
}

export function TwoColumnLayout({ children }: React.PropsWithChildren) {
  return (
    <div className="grid grid-cols-2 gap-x-16 gap-y-4">
      {children}
    </div>
  );
}

export function GridCell({ children, size }: React.PropsWithChildren<{ size?: Size }>) {
  return <div className={clsx("flex flex-col", size === "full" ? "col-span-2" : "col-span-1")}>
    {children}
  </div>
}


export function FlexCentered({ children }: React.PropsWithChildren) {
  return (
    <div className="flex items-center justify-center h-full">
      {children}
    </div>
  );
}
